import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const IconEdit = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName, className);
  return (
    <svg
      className={classes}
      width="14"
      height="14"
      viewBox="0 0 28 28"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.763 20.036a1 1 0 0 1-.057-1.328l.079-.086 7.179-6.961a1 1 0 0 1 1.471 1.35l-.079.085-7.179 6.962a1 1 0 0 1-1.414-.022" />
      <path d="M17.55 1.426a5.02 5.02 0 0 1 7.057.045l1.922 1.922a5.02 5.02 0 0 1 .045 7.057L10.94 26.484A5.02 5.02 0 0 1 7.345 28H2.01A2.01 2.01 0 0 1 0 25.991v-5.336c0-1.354.547-2.65 1.516-3.596zm-1.776 4.536L2.918 18.497a3 3 0 0 0-.91 2.158v5.336h5.337c.813 0 1.59-.328 2.158-.91l12.534-12.856zm7.412-3.07a3.013 3.013 0 0 0-4.234-.028L17.213 4.56l6.226 6.226 1.697-1.738a3.013 3.013 0 0 0 .107-4.09l-.134-.144z" />
    </svg>
  );
};

IconEdit.defaultProps = {
  rootClassName: null,
  className: null,
};

const { string } = PropTypes;

IconEdit.propTypes = {
  rootClassName: string,
  className: string,
};

export default IconEdit;
